"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("react-dates/lib/css/_datepicker.css");

require("react-dates/initialize");

var _moment = _interopRequireDefault(require("moment"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));

var _utils = require("@alycecom/utils");

var _RangeItems = require("./RangeItems");

var _dateRange = require("./dateRange.constants");

var _DateRangeSelectorCalendar = _interopRequireDefault(require("./DateRangeSelectorCalendar"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    calendarPopup: {
      pointerEvents: 'none',
      '& .MuiPopover-paper': {
        pointerEvents: 'auto'
      }
    }
  };
});
/**
 * DateRangeSelect.
 *
 * @function
 * @param {object} props
 * @param {string} [props.from=undefined]
 * @param {string} [props.to=undefined]
 * @param {Function} [props.onChange]
 * @param {string} [props.format=REQUEST_DATE_FORMAT]
 * @param {string} [props.displayFormat=DISPLAY_DATE_FORMAT]
 * @param {boolean} [props.disabled=false]
 * @param {string} [props.minDate=undefined]
 * @param {string} [props.dataTestId='DateRangeSelect']
 * @param {string} [props.label='Viewing']
 * @param {boolean} [props.fullWidth=false]
 * @param {string} [props.className=undefined]
 *
 * @returns {React.ReactNode}
 *
 * @example
 *
 * const handleChange = useCallback(
 *   ({ from, to, preset }) => {
 *     ...
 *   }),
 *   [],
 * );
 *
 * <DateRangeSelect
 *   from="2020-09-24"
 *   to="2020-09-25"
 *   onChange={handleChange}
 *   disabled={isLoading}
 * />
 */

var DateRangeSelect = function DateRangeSelect(_ref) {
  var from = _ref.from,
      to = _ref.to,
      onChange = _ref.onChange,
      format = _ref.format,
      displayFormat = _ref.displayFormat,
      disabled = _ref.disabled,
      label = _ref.label,
      dataTestId = _ref.dataTestId,
      minDate = _ref.minDate,
      formControlProps = (0, _objectWithoutProperties2["default"])(_ref, ["from", "to", "onChange", "format", "displayFormat", "disabled", "label", "dataTestId", "minDate"]);
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isSelectOpened = _useState2[0],
      setIsSelectOpened = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isCalendarOpened = _useState4[0],
      setIsCalendarOpened = _useState4[1];

  var rangeItems = (0, _react.useMemo)(function () {
    return (0, _RangeItems.createRangeItems)(format);
  }, [format]);
  var selectedItem = (0, _react.useMemo)(function () {
    return (0, _RangeItems.getRangeItemByDates)(from, to, rangeItems);
  }, [from, to, rangeItems]);
  var renderSelectedItem = (0, _react.useCallback)(function () {
    if (selectedItem.empty) {
      return selectedItem.label;
    }

    if (selectedItem.custom) {
      return "\n          ".concat((0, _moment["default"])(from, format).format(displayFormat), "\n           - \n          ").concat((0, _moment["default"])(to, format).format(displayFormat), "\n        ");
    }

    return "\n        ".concat((0, _moment["default"])(selectedItem.value.from, format).format(displayFormat), "\n         - \n        ").concat((0, _moment["default"])(selectedItem.value.to, format).format(displayFormat), "\n      ");
  }, [from, to, format, displayFormat, selectedItem]);
  var handleChange = (0, _react.useCallback)(function (range) {
    return onChange(_objectSpread(_objectSpread({}, range), {}, {
      preset: (0, _RangeItems.getRangeItemByDates)(range.from, range.to, rangeItems).label
    }));
  }, [onChange, rangeItems]);
  var handleOpenSelect = (0, _react.useCallback)(function () {
    setIsSelectOpened(true);

    if (selectedItem.custom) {
      setIsCalendarOpened(true);
    }
  }, [selectedItem]);
  var handleCloseSelect = (0, _react.useCallback)(function () {
    if (!isCalendarOpened) {
      setIsSelectOpened(false);
    }
  }, [isCalendarOpened]);
  var handleClickSelectItem = (0, _react.useCallback)(function (event, child) {
    var value = child.props.value;

    if (value.custom) {
      setIsSelectOpened(true);
      setIsCalendarOpened(true);
    } else {
      setIsCalendarOpened(false);
      handleChange(value.value);
    }

    return false;
  }, [handleChange]);
  var handleApplyCustom = (0, _react.useCallback)(function (range) {
    handleChange(range);
    setIsSelectOpened(false);
    setIsCalendarOpened(false);
  }, [handleChange]);
  var handleCloseCalendar = (0, _react.useCallback)(function () {
    setIsCalendarOpened(false);
    setIsSelectOpened(false);
  }, []);
  var select = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_material.FormControl, (0, _extends2["default"])({
    variant: "outlined"
  }, formControlProps), /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
    htmlFor: "date-range-select"
  }, label), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    value: selectedItem,
    renderValue: renderSelectedItem,
    disabled: disabled,
    open: isSelectOpened || isCalendarOpened,
    onOpen: handleOpenSelect,
    onClose: handleCloseSelect,
    IconComponent: _ExpandMore["default"],
    label: label,
    inputProps: {
      id: 'date-range-select'
    },
    onChange: handleClickSelectItem,
    ref: select,
    "data-testid": dataTestId
  }, rangeItems.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      value: item,
      key: item.label,
      "data-testid": (0, _utils.formatTestId)("".concat(dataTestId, ".").concat(item.label))
    }, item.label);
  })), /*#__PURE__*/_react["default"].createElement(_material.Popover, {
    open: isCalendarOpened,
    onClose: handleCloseCalendar,
    anchorEl: select.current,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    className: classes.calendarPopup
  }, /*#__PURE__*/_react["default"].createElement(_DateRangeSelectorCalendar["default"], {
    from: from,
    to: to,
    format: format,
    displayFormat: displayFormat,
    onApply: handleApplyCustom,
    onCancel: handleCloseCalendar,
    dataTestId: dataTestId,
    minDate: minDate
  })));
};

DateRangeSelect.propTypes = {
  from: _propTypes["default"].string,
  to: _propTypes["default"].string,
  format: _propTypes["default"].string,
  displayFormat: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  minDate: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  label: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool
};
DateRangeSelect.defaultProps = {
  from: undefined,
  to: undefined,
  format: _dateRange.REQUEST_DATE_FORMAT,
  displayFormat: _dateRange.DISPLAY_DATE_FORMAT,
  disabled: false,
  minDate: undefined,
  dataTestId: 'DateRangeSelect',
  label: 'Viewing',
  fullWidth: false
};

var _default = /*#__PURE__*/(0, _react.memo)(DateRangeSelect);

exports["default"] = _default;